import { useEffect, useMemo } from "react";

import { useTheme } from "@mui/material";
import { DomUtil } from "leaflet";
import { useMap } from "react-leaflet";
import { getFlowMapMaxCount, formatNum } from "src/lib/number.helpers";
import { type FlowMapFeatureCollection } from "src/types/FlowMapFeatureCollection";

import FlowMapLegendControl from "./FlowMapLegendControl";

function FlowMapLegend({ flowMapRoutes }: { flowMapRoutes: FlowMapFeatureCollection }): null {
  const theme = useTheme();
  const flowMapMax = useMemo(() => getFlowMapMaxCount(flowMapRoutes), [flowMapRoutes]);
  const map = useMap();

  useEffect(() => {
    if (map) {
      if (FlowMapLegendControl.getContainer()) {
        FlowMapLegendControl.remove();
      }
      if (flowMapRoutes.features.length > 0) {
        FlowMapLegendControl.onAdd = () => {
          const div = DomUtil.create("div", "flowMap-legend");
          div.innerHTML = `<div style="color:${theme.palette.text.primary}" class="flowMap-legend-container">
            <div class="flowMap-legend-color-wrapper">
            </div>
            <div class="flowMap-legend-text-wrapper">
              <p>${formatNum(flowMapMax)}</p>
              <p>0</p>
            </div>
          </div>`;
          return div;
        };
        FlowMapLegendControl.addTo(map);
      }
    }
  }, [map, flowMapRoutes, flowMapMax, theme.palette.text.primary]);

  return null;
}

export default FlowMapLegend;
